export const environment = {
    production: false,
    firebase: {
      apiKey: "AIzaSyAkERL4cqimgQc-iuFKDoVy1GIpbx2xG8I",
      authDomain: "alain-nicolas-tello-ee2dd.firebaseapp.com",
      databaseURL: "https://alain-nicolas-tello-ee2dd-default-rtdb.firebaseio.com",
      projectId: "alain-nicolas-tello-ee2dd",
      storageBucket: "alain-nicolas-tello-ee2dd.appspot.com",
      messagingSenderId: "706367434514",
      appId: "1:706367434514:web:339da53d4fc5f683df8dcb",
      measurementId: "G-CDB20WQ53R"
    }
  };